import { FC, RefObject } from 'react'
import Link from 'next/link'
import { Badge, Popover, Whisper } from 'rsuite'
import { useRouter } from 'next/router'

import HeaderCartPopup from '../../Popups/Cart/HeaderCartPopup'
import useUrls from '../../../services/useUrls'
import CartIcon from '../../Icons/CartIcon'
import { useCart } from '../../Cart/CartProvider'
import { selectCartProductsUnique } from '../../Cart/selectors'
import { ScreenSize } from '../../../utils/constants'
import useIsOnMobile from '../../../services/useIsOnMobile'

import cartPopupStyles from '../../../styles/CartPopup.module.less'
import styles from '../../../styles/CartIcon.module.less'

interface CartNavProps {
  headerRef?: RefObject<HTMLDivElement>
  className?: string
}

const CartNav: FC<CartNavProps> = ({ headerRef, className }) => {
  const { urlT } = useUrls()
  const { query } = useRouter()
  const {
    cartState: { cart },
  } = useCart()
  const isOnTablet = useIsOnMobile(ScreenSize.md)

  const { shareParams } = query
  const products = cart ? selectCartProductsUnique(cart) : []
  const productCount = products.length

  return (
    <div
      data-testid="cart-icon"
      className={`${styles['cart-icon-container']} ${className}`}
    >
      <Link href={urlT('/cart')}>
        <Whisper
          container={headerRef?.current ? headerRef.current : undefined}
          placement="bottomEnd"
          trigger={productCount > 0 && !isOnTablet ? 'hover' : 'none'}
          speaker={(
            <Popover
              className={`${cartPopupStyles['cart-popup']} ${cartPopupStyles['header-cart-popup']}`}
              arrow={false}
            >
              <HeaderCartPopup
                cart={cart}
                totalProductsInCart={productCount}
                products={products}
              />
            </Popover>
          )}
          enterable
        >
          <div>
            <Badge
              data-testid="cart-icon-badge"
              className={`${styles.counter} ${
                productCount ? styles['hover-style'] : ''
              }`}
              content={productCount < 1 || shareParams ? false : productCount}
            >
              <CartIcon />
            </Badge>
          </div>
        </Whisper>
      </Link>
    </div>
  )
}

export default CartNav
